<mat-card>
  <div class="row">
    <div class="col-md-10">
<h2>DISHES</h2></div>
<div class="col-md-2">
</div></div>
<div class="row">
  <div class="col-md-8">

  <mat-form-field class="search">
    <mat-label>Search</mat-label>
    <input (keyup)="applyFilter($event.target.value)" matInput placeholder="Search"   >
    </mat-form-field>
</div>

<div class="col-md-4 text-center">
<button mat-button class="add" (click)="addDish()">Add DISH</button></div>
</div>
<table mat-table [dataSource]="memberss" matSort>
    <!-- <ng-container matColumnDef="image">
<th mat-header-cell *matHeaderCellDef mat-sort-header>Image </th>
<td mat-cell *matCellDef="let member"> </td>
</ng-container> -->
  <ng-container matColumnDef="name">
<th mat-header-cell *matHeaderCellDef mat-sort-header>NAME</th>
<td mat-cell *matCellDef="let member" role="gridcell"><div style="color: black;">{{member.name}}</div> </td>
</ng-container>
  <ng-container matColumnDef="description">
<th mat-header-cell *matHeaderCellDef mat-sort-header>DISH DESCRIPTION</th>
<td mat-cell role="gridcell" *matCellDef="let member"> {{member.description}} </td>
</ng-container>
  <ng-container matColumnDef="price">
<th mat-header-cell *matHeaderCellDef mat-sort-header>PRICE</th>
<td mat-cell *matCellDef="let member" role="gridcell"> {{member.price}} </td>
</ng-container>
<ng-container matColumnDef="retail_price">
  <th mat-header-cell *matHeaderCellDef mat-sort-header>RETAIL PRICE</th>
  <td mat-cell role="gridcell" *matCellDef="let member" role="gridcell"> {{member.retail_price}} </td>
  </ng-container>
  <ng-container matColumnDef="image">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>DISH IMAGE</th>
    <td mat-cell *matCellDef="let member" role="gridcell"> <img src="{{member.image.url}}" class="img"></td>
    </ng-container>
  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
    <td mat-cell *matCellDef="let member" role="gridcell"> {{member.status}} </td>
    </ng-container>
    
    
<ng-container matColumnDef="action"  >
<th mat-header-cell *matHeaderCellDef>ACTION</th>
<td mat-cell *matCellDef="let member">
<a class="edit" (click)="edit(member.id)"><mat-icon>edit</mat-icon></a>
<button class="dlt" (click)="deleteDish(member.id,member.image)"><mat-icon>delete</mat-icon></button>

</td>

</ng-container>

<!--in row which column will display is assigned in displayedColumns-->
<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row  (click)="logData(row)" *matRowDef="let row; columns: displayedColumns;"></tr>
			 </table>
<mat-paginator [length]="15" [pageSize]="5" [pageSizeOptions]="[5,10,15]" showFirstLastButtons></mat-paginator>
</mat-card>